/**
 * International Store Selector
 * Handles multiple instances, dropdown toggle, hover, click, keyboard, and tooltips.
 * Inside menu drawer on mobile: opens as a full-screen modal with close icon + backdrop.
 */
(function () {
    var allSelectors = document.querySelectorAll('[data-store-selector]');
    if (!allSelectors.length) return;

    // Shared: global tooltip element on <body>
    var tooltip = document.createElement('div');
    tooltip.className = 'store-selector-tooltip';
    tooltip.setAttribute('role', 'tooltip');
    document.body.appendChild(tooltip);

    // Shared: overlay for desktop header dropdown
    var overlay = document.createElement('div');
    overlay.className = 'store-selector__overlay';
    document.body.appendChild(overlay);

    // Shared: mobile overlay for drawer modal
    var mobileOverlay = document.createElement('div');
    mobileOverlay.className = 'store-selector__mobile-overlay';
    document.body.appendChild(mobileOverlay);

    function showTooltip(anchorEl, text) {
        tooltip.textContent = text;
        tooltip.classList.add('store-selector-tooltip--visible');
        tooltip.classList.remove('store-selector-tooltip--flip');
        tooltip.style.maxWidth = ''; // reset any previous constrained width

        var infoIcon = anchorEl.querySelector('.store-selector__info-icon');
        var anchorRect = infoIcon ? infoIcon.getBoundingClientRect() : anchorEl.getBoundingClientRect();
        var arrowOffset = 14;

        tooltip.style.left = anchorRect.right + 10 + 'px';
        tooltip.style.top = (anchorRect.top + (anchorRect.height / 2) - arrowOffset - 7) + 'px';
        tooltip.style.transform = 'none';

        var tooltipRect = tooltip.getBoundingClientRect();
        if (tooltipRect.right > window.innerWidth - 10) {
            // Check available space on the right side
            var availableRight = window.innerWidth - anchorRect.right - 20;

            if (availableRight >= 120) {
                // Keep on the right, just constrain width to fit
                tooltip.style.maxWidth = availableRight + 'px';
            } else {
                // Not enough space on right at all — flip to left (desktop fallback)
                tooltip.style.left = (anchorRect.left - tooltipRect.width - 10) + 'px';
                tooltip.classList.add('store-selector-tooltip--flip');
            }
        }
        if (tooltipRect.bottom > window.innerHeight - 10) {
            tooltip.style.top = (window.innerHeight - tooltipRect.height - 10) + 'px';
        }
    }

    function hideTooltip() {
        tooltip.classList.remove('store-selector-tooltip--visible');
        tooltip.classList.remove('store-selector-tooltip--flip');
    }

    // Close desktop overlay handler
    overlay.addEventListener('click', function () {
        allSelectors.forEach(function (sel) {
            var t = sel.querySelector('.store-selector__toggle');
            var d = sel.querySelector('.store-selector__dropdown');
            if (t && d) {
                t.setAttribute('aria-expanded', 'false');
                d.hidden = true;
            }
        });
        overlay.classList.remove('store-selector__overlay--active');
        hideTooltip();
    });

    // Close mobile overlay handler
    mobileOverlay.addEventListener('click', function () {
        allSelectors.forEach(function (sel) {
            var t = sel.querySelector('.store-selector__toggle');
            var d = sel.querySelector('.store-selector__dropdown');
            if (t && d) {
                t.setAttribute('aria-expanded', 'false');
                d.hidden = true;
            }
        });
        mobileOverlay.classList.remove('store-selector__mobile-overlay--active');
        hideTooltip();
    });

    // Initialize each instance
    allSelectors.forEach(function (selector) {
        var toggle = selector.querySelector('.store-selector__toggle');
        var dropdown = selector.querySelector('.store-selector__dropdown');
        var links = selector.querySelectorAll('.store-selector__link');
        var closeBtn = dropdown ? dropdown.querySelector('[data-store-selector-close]') : null;

        if (!toggle || !dropdown) return;

        // Detect if this instance is inside the menu drawer
        var isInsideDrawer = !!selector.closest('.menu-drawer');

        function open() {
            toggle.setAttribute('aria-expanded', 'true');
            dropdown.hidden = false;
            if (isInsideDrawer) {
                // Show mobile backdrop overlay behind the full-screen modal
                mobileOverlay.classList.add('store-selector__mobile-overlay--active');
            } else {
                overlay.classList.add('store-selector__overlay--active');
            }
        }

        function close() {
            toggle.setAttribute('aria-expanded', 'false');
            dropdown.hidden = true;
            if (isInsideDrawer) {
                mobileOverlay.classList.remove('store-selector__mobile-overlay--active');
                toggle.focus(); // keep focus inside drawer so onFocusOut doesn't close it
            } else {
                overlay.classList.remove('store-selector__overlay--active');
            }
            hideTooltip();
        }

        function isOpen() {
            return toggle.getAttribute('aria-expanded') === 'true';
        }

        function handleToggle(e) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            if (isOpen()) {
                close();
            } else {
                open();
            }
        }

        // Click toggle
        toggle.addEventListener('click', handleToggle);

        // Keyboard: Enter/Space
        toggle.addEventListener('keydown', function (e) {
            if (e.key === 'Enter' || e.key === ' ') {
                handleToggle(e);
            }
        });

        // Close button (inside modal header)
        if (closeBtn) {
            closeBtn.addEventListener('click', function (e) {
                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation();
                close();
            });

            // Keyboard support for close div (Enter/Space)
            closeBtn.addEventListener('keydown', function (e) {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    e.stopPropagation();
                    e.stopImmediatePropagation();
                    close();
                }
            });
        }

        // Prevent clicks inside dropdown from bubbling to menu drawer
        dropdown.addEventListener('click', function (e) {
            e.stopPropagation();
        });

        // Close on click outside (for desktop header dropdown)
        document.addEventListener('click', function (e) {
            if (isOpen() && !selector.contains(e.target) && !overlay.contains(e.target) && !mobileOverlay.contains(e.target)) {
                close();
            }
        });

        // Keyboard navigation inside dropdown
        selector.addEventListener('keydown', function (e) {
            if (e.key === 'Escape') {
                close();
                toggle.focus();
                e.stopPropagation();
                return;
            }

            if (!isOpen()) return;

            var focusableLinks = Array.from(links);
            var currentIndex = focusableLinks.indexOf(document.activeElement);

            if (e.key === 'ArrowDown') {
                e.preventDefault();
                var next = currentIndex + 1 < focusableLinks.length ? currentIndex + 1 : 0;
                focusableLinks[next].focus();
            }

            if (e.key === 'ArrowUp') {
                e.preventDefault();
                var prev = currentIndex - 1 >= 0 ? currentIndex - 1 : focusableLinks.length - 1;
                focusableLinks[prev].focus();
            }

            if (e.key === 'Tab') {
                if (!e.shiftKey && currentIndex === focusableLinks.length - 1) close();
                if (e.shiftKey && currentIndex === 0) close();
            }
        });

        // Desktop only: hover open/close (skip for drawer instances)
        if (!isInsideDrawer) {
            var hoverTimeout;

            selector.addEventListener('mouseenter', function () {
                if (window.matchMedia('(hover: hover)').matches) {
                    clearTimeout(hoverTimeout);
                    if (!isOpen()) open();
                }
            });

            selector.addEventListener('mouseleave', function () {
                if (window.matchMedia('(hover: hover)').matches) {
                    hoverTimeout = setTimeout(function () {
                        close();
                    }, 300);
                }
            });
        }

        // --- Tooltips ---
        var tooltipLinks = selector.querySelectorAll('.store-selector__link--has-tooltip');
        var activeTooltipLink = null;

        tooltipLinks.forEach(function (link) {
            var tooltipText = link.getAttribute('data-tooltip');
            if (!tooltipText) return;

            link.addEventListener('mouseenter', function () {
                showTooltip(link, tooltipText);
            });

            link.addEventListener('mouseleave', function () {
                hideTooltip();
            });

            link.addEventListener('focus', function () {
                showTooltip(link, tooltipText);
            });

            link.addEventListener('blur', function () {
                hideTooltip();
            });

            link.addEventListener('click', function (e) {
                if (window.matchMedia('(hover: none)').matches) {
                    if (activeTooltipLink !== link) {
                        e.preventDefault();
                        showTooltip(link, tooltipText);
                        activeTooltipLink = link;
                    } else {
                        hideTooltip();
                        activeTooltipLink = null;
                    }
                }
            });
        });

        dropdown.addEventListener('scroll', function () {
            hideTooltip();
        });
    });
})();